import { render, staticRenderFns } from "./SocialShareCopy.vue?vue&type=template&id=187e51a6&scoped=true"
import script from "./SocialShareCopy.vue?vue&type=script&lang=js"
export * from "./SocialShareCopy.vue?vue&type=script&lang=js"
import style0 from "./SocialShareCopy.vue?vue&type=style&index=0&id=187e51a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187e51a6",
  null
  
)

export default component.exports